export function canEditTrainingData(endedAt: string | null): boolean {
  return endedAt === null;
}

export function completedExercises<T extends { sets: { completed: boolean }[] }>(exercises: T[]): T[] {
  return exercises.filter(exercise => exercise.sets.some(set => set.completed));
}

export function completedSetCount(exercises: { sets: { completed: boolean }[] }[]): number {
  return exercises.reduce((total, exercise) => total + exercise.sets.filter(set => set.completed).length, 0);
}
